import { ReturnRequestLogDto } from '@babackapp/private-api-client/types';
import useTranslation from '@babackapp/translations/use-translation';
import { CrossCircledIcon } from '@radix-ui/react-icons';
import ActivityContentWrapper from './activity-content-wrapper';
import ActivityIconWrapper from './activity-icon-wrapper';
import { ActivityItemHeader } from './activity-item-header';
import ActivityWrapper from './activity-wrapper';

type AutomaticCancellationActivityProps = {
  activity: ReturnRequestLogDto;
};

export default function AutomaticCancellationActivity({
  activity,
}: AutomaticCancellationActivityProps) {
  const t = useTranslation();

  return (
    <ActivityWrapper>
      <ActivityIconWrapper>
        <CrossCircledIcon className="size-4" />
      </ActivityIconWrapper>
      <ActivityContentWrapper>
        <div className="flex items-center gap-2">
          <ActivityItemHeader title={``} timestamp={activity.date}>
            <span>{t('returnDetail.automaticCancellation')}</span>
          </ActivityItemHeader>
        </div>
      </ActivityContentWrapper>
    </ActivityWrapper>
  );
}
